import React, { useState } from 'react';

const RELEASES = [
  {
    version: '1.5.0',
    date: '2026-06-09',
    tag: 'latest',
    title: 'Production Launch',
    items: [
      'Promoted to production AWS account (375243950264) in ap-southeast-1, hosted at cpn.cloud-kinetics.com.',
      'Full CDK stack deployed: DynamoDB (all tables with PITR and RETAIN), API Gateway, Lambda, Cognito, S3 — all in Singapore region.',
      'ARR currency renamed from SGD to USD throughout the portal and all data fields.',
      'Deal Value Type label renamed to Deal Source; "Customer Deal" option shortened to "Customer".',
      'Revenue Share % replaced with preset picker (5%, 10%, 15%) with Custom fallback.',
      'Cumulative Revenue KPI added to Partner Dashboard — calculated as sum of ARR × revenue share % across all deals.',
      'Admin group name typo fixed (CKAdmins → CKAdmin) resolving admin login and all admin API calls.',
      'SPA rewrite rule added to Amplify — page refresh on any route no longer returns 404.',
      'CORS updated to allow both cpn.cloud-kinetics.com and Amplify default domain.',
      'Log retention increased to 1 year on all Lambda functions.',
    ]
  },
  {
    version: '1.4.0',
    date: '2026-05-22',
    tag: '',
    title: 'Partner Access Requests',
    items: [
      'Partner access request form now stores submissions in DynamoDB and sends an email notification to the CK admin.',
      'New "Access Requests" tab in User Management — view all pending requests with name, company, country, and message.',
      'One-click "Invite" button on each request pre-fills the invite form with the requester\'s details.',
      'SES email notification sent to rajesh.j@cloud-kinetics.com on every new submission.',
    ]
  },
  {
    version: '1.3.0',
    date: '2026-05-21',
    tag: '',
    title: 'User Management & Dashboard KPIs',
    items: [
      'Added Delete User capability — admins can remove any Cognito user directly from the Users tab.',
      'CK Dashboard KPIs expanded: Pipeline ARR, Submitted, In Review, Approved, Active, Closed Won, and unique Partner count.',
      'CPN ID moved to first column in All Deals table for quicker scanning.',
      'Admin can now edit all fields on any opportunity (not just status and stage).',
    ]
  },
  {
    version: '1.2.0',
    date: '2026-05-20',
    tag: '',
    title: 'CK Branding & Pipeline View',
    items: [
      'Full rebrand to Cloud Kinetics design system — Federal Blue (#07004D), Mint (#1DBE9C), IBM Plex Sans, pill buttons, CK logo from CDN.',
      'Kanban Pipeline View across 6 deal stages: New, Qualification, Proposal, Negotiation, Closed Won, Closed Lost.',
      'Partner Dashboard with KPI cards (Total, Active Pipeline ARR, Closed Won) and recent submissions.',
      'Inline editing on Opportunity Detail — edit all sections without leaving the page.',
    ]
  },
  {
    version: '1.1.0',
    date: '2026-05-19',
    tag: '',
    title: 'Admin Dashboard & Analytics',
    items: [
      'CK Admin dashboard with bar charts: by deal type, stage, deal value type, resell/PS sub-categories, partner, and country.',
      'ARR by Deal Type summary cards.',
      'Admin All Deals table with inline status and stage dropdowns.',
      'CSV export of all opportunities.',
      'User invitation (Cognito) and listing via admin panel.',
    ]
  },
  {
    version: '1.0.0',
    date: '2026-05-18',
    tag: '',
    title: 'Initial Launch',
    items: [
      'Invite-only partner portal on AWS (Amplify + API Gateway + Lambda + DynamoDB + Cognito).',
      'Partner opportunity submission form with CPN ID auto-generation.',
      'Opportunity detail view with audit log and comments/activity feed.',
      'Document upload via S3 pre-signed URLs.',
      'Role-based access: Partners see their own deals; CK Admins see everything.',
    ]
  }
];

export default function ReleaseNotes() {
  const [expanded, setExpanded] = useState('1.5.0');

  return (
    <div className="release-notes">
      <div className="release-notes-header">
        <h2>Release Notes</h2>
        <span className="release-notes-sub">CK Partner Network — change history</span>
      </div>

      <div className="release-list">
        {RELEASES.map(r => (
          <div
            key={r.version}
            className={`release-card${expanded === r.version ? ' release-card--open' : ''}`}
          >
            <button
              className="release-card-header"
              onClick={() => setExpanded(expanded === r.version ? null : r.version)}
            >
              <div className="release-meta">
                <span className="release-version">v{r.version}</span>
                {r.tag && <span className="release-tag">{r.tag}</span>}
                <span className="release-title">{r.title}</span>
              </div>
              <span className="release-date">{new Date(r.date).toLocaleDateString('en-SG', { day: 'numeric', month: 'short', year: 'numeric' })}</span>
            </button>

            {expanded === r.version && (
              <ul className="release-items">
                {r.items.map((item, i) => (
                  <li key={i}>{item}</li>
                ))}
              </ul>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
